import { Stack, Box } from "@mui/material";

import { HubToolbar } from "../../components";
import { useGetWorkOrderFloorInstructions } from "../../hooks";

import PartDetailsFields from "./PartDetailsFields";
import { StyledDrawer } from "./styles";

const PartDetailsDrawer = ({ routeId, setOpen = () => {} }) => {
  const onClose = () => setOpen(null);

  const { data, isLoading } = useGetWorkOrderFloorInstructions(routeId);

  const open = !!routeId && !!data && !isLoading;
  return (
    <StyledDrawer anchor="right" open={open} onClose={onClose}>
      <Stack overflow="hidden">
        <HubToolbar
          label={`${data?.partNumber ?? ""} - ${data?.partName ?? ""}`}
          onClose={onClose}
          direction="left"
        />
        <Box
          sx={{
            height: "100%",
            overflowY: "auto",
            padding: "0 0 25px 0",
            "&::-webkit-scrollbar": { display: "none !important" },
          }}
        >
          <Stack padding="25px" gap="25px" width="100%">
            <PartDetailsFields data={data} />
          </Stack>
        </Box>
      </Stack>
    </StyledDrawer>
  );
};

export const PartDetailsDrawerDialog = PartDetailsDrawer;
